/** Remove inline style from tablepress tables. */
export function tablepressFix(): void {
	const tablepressElement = document.querySelector(".tablepress");

	if (!tablepressElement) return;

	const dataTablesWrapper = document.querySelectorAll(".dataTables_wrapper");

	if (dataTablesWrapper.length > 0) {
		dataTablesWrapper.forEach((wrapper) => {
			const tableElements = Array.from(wrapper.querySelectorAll("[style]"));

			tableElements.forEach((table) => {
				const existingStyle = table.getAttribute("style");
				if (existingStyle) {
					const newStyle = existingStyle.replace("width: 1158px;", "");
					table.setAttribute("style", newStyle);
				}
			});
		});
	} else {
		setTimeout(() => {
			tablepressFix();
		}, 100);
	}
}
